import React from 'react';
import {useForm} from "react-hook-form";
import {NavLink, useNavigate} from "react-router-dom";
import {album} from "../../../models/album";
import {albumResultType} from "../../../types/Api/AlbumResultType";
import {Require} from "../Require";
import {ApiError, ApiService} from "../../../service/ApiService";
import {scrollTo} from "../../../service/ToolsService";

type FormDataType = {
  label: string;
  enabled: boolean;
}

type AlbumFormProps = {
  album?: album,
}

export const AlbumForm = ({album}: AlbumFormProps) => {
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    setError,
    watch,
    formState: {errors, isSubmitting}
  } = useForm<FormDataType>({
    defaultValues: {
      label: album?.label,
      enabled: album?.enabled ?? false,
    }
  });

  const onSubmit = async (data: FormDataType) => {
    const d = {
      label: data.label,
      enabled: data.enabled,
    };

    try {
      if (album) {
        await ApiService.patch(`/album/${album.albumId}`, { param: () => d })
        navigate('/admin/album')
      } else {
        const created = await ApiService.post('/album', { param: () => d }) as albumResultType;
        // On reste sur l'album créé pour pouvoir y ajouter les photos
        navigate(`/admin/album/edit/${created.albumId}`)
      }

      scrollTo();
    } catch (e: any) {
      const error: ApiError = e as ApiError;

      error.errors?.forEach((e: {
        field: string,
        message: string
      }) => {
        setError(e.field as "label" | "enabled", {
          type: "manual",
          message: e.message
        })
      });
    }
  }

  return (
    <>
      <form className="p-3" method="post" onSubmit={handleSubmit(onSubmit)}>
        <div className="max-w600px">
          <div className="form-check form-switch mb-3">
            <input className="form-check-input" type="checkbox" id="form-enabled" {...register('enabled')} />
            <label className="form-check-label" htmlFor="form-enabled">
              L'album est {`${watch('enabled') ? 'visible' : 'masqué'}`} sur le site
            </label>
          </div>
          <div className="mb-3">
            <label className="form-label" htmlFor="form-label">Nom <Require/></label>
            <input id="form-label" type="text" className="form-control" placeholder="~" {...register('label', {
              required: 'Le nom est requis',
              validate: {
                maxLength: (value) =>
                  (value ?? '').length <= 255 || 'Le nom ne doit pas dépasser 255 caractères',
              },
            })} />
            {errors.label && <p className="text-danger">{errors.label.message}</p>}
          </div>
          {!album && (
            <p className="text-muted small">
              <i className="fa-solid fa-circle-info me-1"/>
              Les photos pourront être ajoutées une fois l'album créé.
            </p>
          )}
        </div>

        <div className="mt-3">
          <button className="btn btn-sm btn-success me-1" type="submit" disabled={isSubmitting}>
            {album ? 'Enregistrer' : 'Créer et ajouter des photos'}
          </button>
          <NavLink to={`/admin/album`} onClick={scrollTo} className="btn btn-sm btn-info">Retour aux albums</NavLink>
        </div>
      </form>
    </>
  );
}
